export default __webpack_public_path__ + "static/media/mediterraneansnack.aded50fb.jpg";